import { ComponentProps } from 'react'

type StartLogoVerdeProps = ComponentProps<'svg'>

export default function StartLogoVerde({
  title,
  ...props
}: StartLogoVerdeProps & { title?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      aria-label={title}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M15.7596 31.9792C15.2993 31.9106 14.8871 31.6499 14.626 31.2588C13.1902 29.0976 11.2941 26.6139 8.82782 24.0959C5.89438 21.0976 3.11207 18.8815 0.66638 17.2898C0.309146 17.0565 0.0480893 16.686 0.0068699 16.2538C0.0068699 16.2057 0 16.1646 0 16.1165C0 15.9038 0.0480893 15.698 0.137398 15.5059C0.240447 15.2795 0.425934 15.1011 0.632031 14.9639C2.9678 13.4407 5.61958 11.3413 8.44311 8.52139C11.2323 5.72895 13.3139 2.98454 14.8321 0.665519C15.0657 0.308746 15.4367 0.0480272 15.8695 0.00686102C15.9107 0 15.9588 0 16.0069 0C16.2198 0 16.4259 0.0480272 16.6183 0.13722C16.845 0.240136 17.0236 0.425383 17.1541 0.631214C18.7548 3.0806 20.9738 6.00339 23.9897 8.94677C26.6346 11.5265 29.1009 13.4819 31.3336 14.9433C31.6909 15.1766 31.9519 15.5471 31.9931 15.9793C31.9931 16.0273 32 16.0685 32 16.1165C32 16.3292 31.9519 16.5351 31.8626 16.7272C31.7596 16.9536 31.5741 17.132 31.3611 17.2692C29.0666 18.7649 26.4835 20.7958 23.7286 23.5264C20.9669 26.2571 18.8922 28.9604 17.3671 31.2588C17.0236 31.7803 16.4122 32.0684 15.7939 31.9861C15.7802 31.9861 15.7664 31.9861 15.7458 31.9861L15.7596 31.9792Z"
        fill="#054532"
      />
      <path
        d="M21.8055 10.47L13.4517 16.1646C13.3899 16.2058 13.5135 16.1303 13.4517 16.1646C11.1159 17.5711 9.87247 15.8284 9.87247 14.5385V10.4082C9.87247 10.1132 10.1129 9.87305 10.4083 9.87305H21.9085C22.0322 9.87305 22.1078 9.92107 22.1352 9.99654C22.1765 10.1132 22.1146 10.2641 21.8055 10.47Z"
        fill="#60DC9E"
      />
      <path
        d="M10.2083 21.5295L18.5621 15.8349C18.5003 15.8692 18.624 15.7937 18.5621 15.8349C20.8979 14.4284 22.1414 16.1711 22.1414 17.461V21.5913C22.1414 21.8863 21.9009 22.1264 21.6055 22.1264H10.1053C9.98164 22.1264 9.90607 22.0784 9.87859 22.0029C9.83737 21.8863 9.8992 21.7354 10.2083 21.5295Z"
        fill="#60DC9E"
      />
    </svg>
  )
}
